import { createTheme } from '@mui/material/styles';
import { green, amber } from '@mui/material/colors';


export const THCTheme = createTheme(
  {
    palette: 
    {
      primary: green,
      secondary: amber,
    },

    components: 
    {
      MuiListItem:
      {
        styleOverrides:
        {
          root:
          {
            variants: 
            [
              {
                props: 
                {
                  variant: 'special',
                },
                style:
                {
                  backgroundColor: `${amber[200]}`
                }
              },   
              {
                props: 
                {
                  variant: 'level-1',
                },
                style:
                {
                //  backgroundColor: `${green[200]}`
                }
              },   
              {
                props: 
                {
                  variant: 'level-1',
                  color: 'secondary'
                },
                style:
                {
                  backgroundColor: `${amber[200]}`
                }
              },               
              {
                props: 
                {
                  variant: 'level-2',
                },
                style:
                {
                  backgroundColor: `${green[100]}`
                }
              },   
              {
                props: 
                {
                  variant: 'level-2',
                  color: 'secondary'
                },
                style:
                {
                  backgroundColor: `${amber[100]}`
                }
              }, 
              {
                props: 
                {
                  variant: 'level-3',
                },
                style:
                {
                  backgroundColor: `${green[50]}`
                }
              },   
              {
                props: 
                {
                  variant: 'level-3',
                  color: 'secondary'
                },
                style:
                {
                  backgroundColor: `${amber[50]}`
                }
              },              
              {
                props: 
                {
                  variant: 'level-4',
                },
                style:
                {
                  backgroundColor: `${green[100]}`
                }
              },
              {
                props: 
                {
                  variant: 'level-5',
                },
                style:
                {
                  backgroundColor: `${green[50]}`
                }
              }
            ]
          }
        }
      }
    },
  }
);

